<template>
  <DialogContent class="flex flex-col items-center text-center">
    <Pill class="mt-[3px] mb-4" success>{{ upsell?.pillText }}</Pill>

    <div
      class="font-primary font-semibold text-[22px] leading-[24px] text-gray-800 w-3/4 mb-2.5"
    >
      Want to get more and pay less?
    </div>

    <div class="mb-6">
      <span class="font-medium slant text-green-600">Save 33%</span> on each
      copyright by upgrading. Get
      <span class="font-medium slant text-green-600">
        {{ upsell?.planItem.maxUnits }} copyrights
      </span>
      for only {{ priceAndCycle }}.
    </div>

    <UiButton class="w-full! mb-3 min-h-10!" primary large @click="handleClick">
      Yes, upgrade my plan
    </UiButton>

    <div class="text-link" @click="handleRejectClick">
      No, I want to pay more
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import {
  PlanPriceType,
  useTrackEventMutation,
} from '@/shared/graphql/legacy/generated'
import { useBillingStore } from '@/features/billing/store'
import { Pill, UiButton } from '@dacr/ui'
import posthog from 'posthog-js'
import { computed, onMounted } from 'vue'

const { close } = useDialog()

const { mutate: trackEvent } = useTrackEventMutation()

const billingStore = useBillingStore()

const upsell = computed(() => billingStore.selectedPlanItem?.upsell)

const priceAndCycle = computed(() => {
  const subscriptionPrice = upsell.value?.planItem.prices.find(
    (price) => price.type === PlanPriceType.Subscription
  )

  return `${subscriptionPrice?.details?.renderedPrice} /month`
})

onMounted(() => {
  posthog.capture('upsell_modal_shown', {
    id: upsell.value?.planItem.productId,
    plan: upsell.value?.plan,
    planItem: upsell.value?.planItem,
  })

  const subscriptionPrice = upsell.value?.planItem.prices.find(
    (price) => price.type === PlanPriceType.Subscription
  )

  trackEvent({
    name: 'upsell_modal_shown',
    data: JSON.stringify({
      id: upsell.value?.planItem.productId,
      data: {
        PLAN: upsell.value?.plan.name,
        AMOUNT: subscriptionPrice?.details?.amount || 0,
      },
    }),
  })
})

const handleRejectClick = () => {
  posthog.capture('upsell_modal_rejected', {
    id: upsell.value?.planItem.productId,
    plan: upsell.value?.plan,
    planItem: upsell.value?.planItem,
  })

  close()
}

const handleClick = () => {
  if (!upsell.value?.plan || !upsell.value.planItem) return

  posthog.capture('upsell_modal_accepted', {
    id: upsell.value?.planItem.productId,
    plan: upsell.value?.plan,
    planItem: upsell.value?.planItem,
  })

  billingStore.setPlanData({
    plan: upsell.value?.plan,
    planItem: upsell.value?.planItem,
    billingCycle: billingStore.selectedBillingCycle,
  })

  close()
}
</script>
